export interface ToolingCostLineData {
	accessoriesCost: number;
	amortised: boolean; // if true: toolingTotalCost / batchSize added to piece cost
	assemblyCost: number;
	assemblyHours: number;
	assemblyRate: number;
	autoFormCost: number;
	autoFormHours: number;
	autoFormRate: number;
	blowsPerTool: number;
	// The default each rate was filled from - a rate that differs from it was changed by hand and needs approval.
	defaultAssemblyRate?: number;
	defaultAutoFormRate?: number;
	defaultDesignRate?: number;
	defaultMachineRate?: number;
	defaultQualityRate?: number;
	designCost: number;
	designHours: number;
	designRate: number;
	expanded: boolean; // UI state, not persisted
	fastQuoteTotalCost: number;
	id: string; // UUID for panel tracking
	machineCost: number;
	machineHours: number;
	machineRate: number;
	marginCost: number; // calculated: toolingTotalCost * marginPercentage
	marginPercentage: number;
	name: string;
	qualityCost: number;
	qualityHours: number;
	qualityRate: number;
	quoteType: "fast" | "breakout";
	stageNumber: number;
	toolingMaterialCost: number; // single cost field, replaces billets dimensions
	toolingTotalCost: number; // calculated
}

export class ToolingCostLineData implements ToolingCostLineData {
	accessoriesCost = 0;
	amortised = false;
	assemblyCost = 0;
	assemblyHours = 0;
	assemblyRate = 0;
	autoFormCost = 0;
	autoFormHours = 0;
	autoFormRate = 0;
	blowsPerTool = 1;
	designCost = 0;
	designHours = 0;
	designRate = 0;
	expanded = true;
	fastQuoteTotalCost = 0;
	id = "";
	machineCost = 0;
	machineHours = 0;
	machineRate = 0;
	marginCost = 0;
	marginPercentage = 0;
	name = "Tool";
	qualityCost = 0;
	qualityHours = 0;
	qualityRate = 0;
	quoteType: "fast" | "breakout" = "fast";
	toolingMaterialCost = 0;
	toolingTotalCost = 0;
	constructor(data?: Partial<ToolingCostLineData>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}
